import { FEATURE } from '@src/constants/package';
import {
  AUDIO_STATUSES,
  CATEGORIES,
  VOICE_STATUSES,
} from '@src/constants/voiceCloning';
// import moment from 'moment';

const getCategoryLabel = (value) => {
  const category = CATEGORIES.find((item) => item.value === value);
  return category ? category.label : value;
};

const getAudioStatus = (value) => {
  const status = AUDIO_STATUSES.find((item) => item.value === value);
  return status ? status.label : value;
};

const getVoiceStatusLabel = (value) => {
  const voice = VOICE_STATUSES.find((item) => item.value === value);

  return voice ? voice.label : value;
};

const validateUserPackageCanUseVoiceCloning = (ttsUser) => {
  if (!ttsUser) return false;
  return ttsUser?.features?.includes(FEATURE.AI_VOICE_CLONING);
};

export {
  getCategoryLabel,
  getAudioStatus,
  getVoiceStatusLabel,
  validateUserPackageCanUseVoiceCloning,
};
